import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d33e8234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" }, null, -1))
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "p-mb-2 p-mt-1 p-text-bold p-text-uppercase",
  style: {"color":"#004c97"}
}
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = { class: "p-mr-2 p-text-uppercase" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " TO : ", -1))
const _hoisted_10 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Receipt NO : ", -1))
const _hoisted_12 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " DATE : ", -1))
const _hoisted_14 = {
  key: 0,
  class: "p-mx-2 p-text-uppercase"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " DUE DATE : ", -1))
const _hoisted_16 = { class: "p-grid" }
const _hoisted_17 = { class: "p-col" }
const _hoisted_18 = { class: "p-grid" }
const _hoisted_19 = { class: "p-col-12" }
const _hoisted_20 = { class: "table table-bordered total-lables" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "p-col-12" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Receipt Payments", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "previewReceiptDailog",
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '100vw' },
    position: "top",
    class: "p-fluid p-m-0 p-dialog-maximized",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        type: "button",
        label: "Print",
        icon: "pi pi-print",
        class: "p-button-warning pull-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printReceipt()))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.item.storeName), 1),
          _createElementVNode("h6", null, "Address: " + _toDisplayString(_ctx.item.storeAddress), 1),
          _createElementVNode("h6", null, "Email: " + _toDisplayString(_ctx.item.storeEmail), 1),
          _createElementVNode("h6", null, "Ph:" + _toDisplayString(_ctx.item.storePhone), 1),
          _createElementVNode("h6", null, "License No : " + _toDisplayString(_ctx.item.storeLicense), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "company-logo",
            src: _ctx.getCompanyURL(),
            alt: "Company Logo"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.previewHeading), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.item.selectedProfile), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.item.receiptNO), 1)
          ]),
          _createElementVNode("span", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.item.receiptDate)), 1)
          ]),
          (_ctx.previewHeading == 'Invoice')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.item.receiptDueDate)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_DataTable, {
            value: _ctx.item.itemList,
            class: "p-datatable-sm p-datatable-gridlines"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                style: {"width":"30%"},
                class: "p-p-1",
                field: "accountHead",
                header: "ACCOUNT NAME"
              }),
              _createVNode(_component_Column, {
                style: {"width":"10%"},
                class: "p-p-1",
                header: "QTY",
                field: "quantity"
              }),
              _createVNode(_component_Column, {
                style: {"width":"10%"},
                class: "p-p-1",
                header: "PRICE"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.price)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                style: {"width":"10%"},
                class: "p-p-1",
                header: "DISC(%)"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.discount)), 1)
                ]),
                _: 1
              }),
              (_ctx.taxNames[0] && _ctx.taxNames[0].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    class: "p-p-1",
                    header: _ctx.taxNames[0]?.taxName + '(%)',
                    style: {"width":"10%"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.tax1Value)), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1] && _ctx.taxNames[1].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    class: "p-p-1",
                    header: _ctx.taxNames[1]?.taxName + '(%)',
                    style: {"width":"10%"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.tax2Value)), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2] && _ctx.taxNames[2].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 2,
                    class: "p-p-1",
                    header: _ctx.taxNames[2]?.taxName + '(%)',
                    style: {"width":"10%"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.tax3Value)), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                header: "SUBTOTAL",
                style: {"width":"10%"}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.subTotal)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("p", null, "Description : " + _toDisplayString(_ctx.item.description), 1),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, " Total Gross : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalGross)), 1),
              _createElementVNode("td", null, " Total Disc : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalDiscount)), 1),
              (_ctx.taxNames[0] && _ctx.taxNames[0].show == 'true')
                ? (_openBlock(), _createElementBlock("td", _hoisted_21, " Total " + _toDisplayString(_ctx.taxNames[0]?.taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalTax1)), 1))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1] && _ctx.taxNames[1].show == 'true')
                ? (_openBlock(), _createElementBlock("td", _hoisted_22, " Total " + _toDisplayString(_ctx.taxNames[1]?.taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalTax2)), 1))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2] && _ctx.taxNames[2].show == 'true')
                ? (_openBlock(), _createElementBlock("td", _hoisted_23, " Total " + _toDisplayString(_ctx.taxNames[2]?.taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalTax3)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, " Total Tax : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalTax)), 1),
              _createElementVNode("td", null, " Net Total : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.item.totalBill)), 1),
              _createElementVNode("td", null, " Balance : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalBalance)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_DataTable, {
            value: _ctx.PaymentLists,
            scrollable: true,
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
          }, {
            empty: _withCtx(() => [
              _hoisted_26
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Created Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.createdDate)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "sourceType",
                header: "Type"
              }),
              _createVNode(_component_Column, { header: "Receipt No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.receiptNo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "paymentType",
                header: "Payment Type"
              }),
              _createVNode(_component_Column, { header: "Total Amount" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.transTotalAmount)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "description",
                header: "Description"
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}